import { AdvancedMarker, type AdvancedMarkerProps, InfoWindow, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { useState } from 'react';
import type ZorgbaseResult from '@/lib/models/zorgbase/ZorgbaseResult';
import { getOrganisationDisplayName, pointToPosition } from '@/lib/util';
import type { MapDisplayType } from './MapDisplay';
import MapMarkerIcon from './MapMarkerIcon';

export interface MapMarkerProps extends Omit<AdvancedMarkerProps, 'position'> {
	organisation: ZorgbaseResult;
	type: MapDisplayType;
}

const MapMarker = (props: MapMarkerProps) => {
	const [infowindowOpen, setInfowindowOpen] = useState(false);
	const [markerRef, marker] = useAdvancedMarkerRef();
	const scale = 8;

	const { organisation, ...other } = props;

	const markerPosition = pointToPosition(organisation);
	const displayName = getOrganisationDisplayName(organisation);

	return (
		markerPosition && (
			<AdvancedMarker
				ref={markerRef}
				position={markerPosition}
				onClick={(e) => {
					e.preventDefault();
					setInfowindowOpen(true);
				}}
				{...other}
				title={organisation.label}
			>
				<MapMarkerIcon organisation={organisation} setInfowindowOpen={setInfowindowOpen} />

				{infowindowOpen && (
					<InfoWindow
						anchor={marker}
						maxWidth={200}
						onCloseClick={() => setInfowindowOpen(false)}
						pixelOffset={[0, -(2 + scale)]}
						disableAutoPan={true}
						shouldFocus={false}
						headerContent={displayName}
					/>
				)}
			</AdvancedMarker>
		)
	);
};

export default MapMarker;
